<template>
    <div id="last-cta" class="homepage__last-cta">
        <div class="last-cta">
            <h2 class="last-cta__title">
                {{ $t('lp.cta.signUpAs') }}
            </h2>
            <SignUpButtons
                :teacher-role-text="
                    currentLanguage === 'en'
                        ? $t('auth.registration.roleTeacherLong')
                        : $t('auth.registration.roleTeacher')
                "
                :student-role-text="
                    currentLanguage === 'en'
                        ? $t('auth.registration.roleStudentLong')
                        : $t('auth.registration.roleStudent')
                "
                :parent-role-text="
                    currentLanguage === 'en'
                        ? $t('auth.registration.roleParentLong')
                        : $t('auth.registration.roleParent')
                "
            />
        </div>
    </div>
</template>

<script>
import SignUpButtons from '@/landing/flows/LandingPage/components/SignUpButtons.vue';
import { mapGetters } from 'vuex';

export default {
    components: { SignUpButtons },
    computed: {
        ...mapGetters({ currentLanguage: 'getCurrentLanguage' }),
    },
};
</script>

<style lang="scss">
.homepage__last-cta {
    background-color: #fff;
    color: #333333;
    position: relative;
    z-index: 1;

    &::before {
        content: '';
        display: block;
        width: 100%;
        background-color: #fff;
        position: absolute;
        left: 0;
        z-index: -1;
        transform: skewY(4deg);
        top: -50px;
        height: 75px;

        @include mq($w-min-md, min) {
            height: 100px;
            top: -60px;
        }

        @include mq($w-min-desktop, min) {
            transform: skewY(2deg);
            border-top: 20px solid #b686f6;
        }

        @include mq($w-min-wide-desktop, min) {
            top: -35px;
        }
    }

    .last-cta {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem 1rem 4rem;
        margin-bottom: -2rem;

        @include mq($w-min-md, min) {
            margin-bottom: 0;
            padding-top: 4rem;
            padding-bottom: 6rem;
        }

        &__title {
            font-style: normal;
            font-weight: bold;
            font-size: 1.25rem;
            line-height: 1.25rem;
            color: #333333;
            text-align: center;
            padding: 1rem;

            @include mq($w-min-desktop, min) {
                font-size: 3rem;
                line-height: 3.75rem;
                padding: 2rem;
            }
        }
    }
}
</style>
